import { getStoredSession } from './session';

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || '';

export async function callFunction<TInput extends Record<string, unknown>, TOutput>(name: string, input: TInput): Promise<TOutput> {
  const session = getStoredSession();
  const response = await fetch(`${apiBaseUrl}/api/${name}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(session?.token ? { Authorization: `Bearer ${session.token}` } : {}),
    },
    body: JSON.stringify(input),
  });
  const payload = await response.json().catch(() => ({})) as { error?: string };
  if (!response.ok || payload.error) throw new Error(payload.error || 'ارتباط با سرور مسابقه برقرار نشد.');
  return payload as TOutput;
}

export async function fetchArenaState<TOutput>(): Promise<TOutput> {
  const session = getStoredSession();
  if (!session?.token) throw new Error('کد ورود پیدا نشد؛ دوباره وارد شوید.');
  const response = await fetch(`${apiBaseUrl}/api/state`, {
    headers: { Authorization: `Bearer ${session.token}` },
  });
  const payload = await response.json().catch(() => ({})) as { error?: string };
  if (!response.ok || payload.error) throw new Error(payload.error || 'وضعیت مسابقه دریافت نشد.');
  return payload as TOutput;
}

export function errorMessage(error: unknown): string {
  if (typeof error === 'object' && error && 'message' in error && typeof error.message === 'string') {
    return error.message.replace(/^Firebase:\s*/i, '').replace(/\s*\(functions\/.+\)\.?$/, '');
  }
  return 'عملیات انجام نشد. دوباره تلاش کنید.';
}
